import React, { useState } from "react";
import GuestsInput from "../GuestsInput";
import LocationInput from "../LocationInput";
import DatesRangeInput from "../DatesRangeInput";
//import { loadLanguages } from "i18next";
import { useClient } from "ClientContext"; 



const StaySearchForm = () => {
  const [guestInput, setGuestInput] = useState({
    guestCount: 0,
  });
  const {isLocationFilter} = useClient()
  const [locationInputTo, setLocationInputTo] = useState("");

  const renderInputLocation = () => {
    return (
      <div className="w-full bg-white dark:bg-neutral-800 rounded-2xl shadow-lg">
        <LocationInput
          defaultValue={locationInputTo}
          onChange={(value) => setLocationInputTo(value)}
        />
      </div>
    );
  };

  const renderInputDates = () => {
    return (
      <div className="w-full bg-white dark:bg-neutral-800 rounded-2xl shadow-lg overflow-hidden">
        <DatesRangeInput />
      </div>
    );
  };

  const renderInputGuests = () => {


    return (
      <div className="w-full bg-white dark:bg-neutral-800 rounded-2xl shadow-lg overflow-hidden">
        <GuestsInput
          defaultValue={guestInput}
          onChange={(newValue) => setGuestInput({ guestCount: newValue })}
        />
      </div>
    );
  };

  return (
    <div>
      <div className="w-full space-y-5">
        {isLocationFilter && renderInputLocation()}
        {renderInputDates()}
        {renderInputGuests()}
      </div>
    </div>
  );
};

export default StaySearchForm;